import { render, staticRenderFns } from "./Paperfm.vue?vue&type=template&id=f21207d8&scoped=true"
import script from "./Paperfm.vue?vue&type=script&lang=js"
export * from "./Paperfm.vue?vue&type=script&lang=js"
import style0 from "./Paperfm.vue?vue&type=style&index=0&id=f21207d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21207d8",
  null
  
)

export default component.exports